import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';

export const getMetadataState = createSelector(
    fromFeature.getFeatureState,
    (state: fromFeature.FeatureState) => state.metadata,
);
